export function duration(time: number): number {
  const duration1 = Math.floor(Date.now() / 1_000) - Math.floor(time / 1_000);
  return Math.round(duration1) * 1_000;
}
